var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserFrameSilver(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 623.65,
    height: 573.224,
    viewBox: "0 0 165.007 151.665",
    id: "svg16948",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-7.405 -53.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17259",
    transform: "matrix(.26458 0 0 .26458 -17.66 15.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17008"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 949.401,
    y1: 662.536,
    x2: 949.401,
    y2: 70.871,
    gradientTransform: "rotate(-41.721 530.348 1286.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faf8f7"
    },
    id: "stop16982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "#f0edee"
    },
    id: "stop16984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    style: {
      stopColor: "#d7d1d7"
    },
    id: "stop16986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    style: {
      stopColor: "#ada3b0"
    },
    id: "stop16988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    style: {
      stopColor: "#74647b"
    },
    id: "stop16990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    style: {
      stopColor: "#594562"
    },
    id: "stop16992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4a2e47"
    },
    id: "stop16994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 949.282,
    y1: 593.912,
    x2: 949.282,
    y2: 70.107,
    gradientTransform: "rotate(-41.721 530.348 1286.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a1776b"
    },
    id: "stop16999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#68556f"
    },
    id: "stop17001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e2d7d2"
    },
    id: "stop17003"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g17054"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.244,
    y1: 638.328,
    x2: 408.244,
    y2: 142.976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a97570"
    },
    id: "stop17010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#724562"
    },
    id: "stop17012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    style: {
      stopColor: "#89647b"
    },
    id: "stop17014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    style: {
      stopColor: "#b9a3b0"
    },
    id: "stop17016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    style: {
      stopColor: "#dcd1d7"
    },
    id: "stop17018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912,
    style: {
      stopColor: "#f2edee"
    },
    id: "stop17020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#faf8f7"
    },
    id: "stop17022"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408.24 142.98c-136.77 0-247.68 110.91-247.68 247.68s110.91 247.68 247.68 247.68c136.83 0 247.68-110.91 247.68-247.68S545.08 142.98 408.24 142.98zm0 466.17c-120.61 0-218.43-97.82-218.43-218.5s97.82-218.5 218.43-218.5c120.68 0 218.5 97.82 218.5 218.5s-97.82 218.5-218.5 218.5z",
    id: "path17025",
    style: {
      fill: "url(#SVGID_5_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.276,
    y1: 631.177,
    x2: 408.276,
    y2: 150.128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7a28b"
    },
    id: "stop17027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    style: {
      stopColor: "#b5867d"
    },
    id: "stop17029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#8b636b"
    },
    id: "stop17031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    style: {
      stopColor: "#6c495f"
    },
    id: "stop17033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#593a57"
    },
    id: "stop17035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#523454"
    },
    id: "stop17037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    style: {
      stopColor: "#7b647c"
    },
    id: "stop17039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    style: {
      stopColor: "#b1a3b0"
    },
    id: "stop17041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    style: {
      stopColor: "#d9d1d7"
    },
    id: "stop17043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    style: {
      stopColor: "#f1edee"
    },
    id: "stop17045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#faf8f7"
    },
    id: "stop17047"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408.24 150.13c-132.81 0-240.46 107.72-240.46 240.52 0 132.87 107.65 240.52 240.46 240.52 132.87 0 240.53-107.65 240.53-240.52 0-132.81-107.65-240.52-240.53-240.52zm0 459.02c-120.61 0-218.43-97.82-218.43-218.5s97.82-218.5 218.43-218.5c120.68 0 218.5 97.82 218.5 218.5s-97.82 218.5-218.5 218.5z",
    id: "path17050",
    style: {
      fill: "url(#SVGID_6_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34 546.76s71.02 74.66 182.93 74.66c111.91 0 182.95-74.66 182.95-74.66s-64.43 84.41-182.95 84.41c-118.52 0-182.93-84.41-182.93-84.41z",
    id: "path17052",
    style: {
      opacity: 0.8,
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g17131"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 624.377,
    y1: 592.972,
    x2: 624.377,
    y2: 285.808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7a28b"
    },
    id: "stop17056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#8e6a81"
    },
    id: "stop17058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#b5999f"
    },
    id: "stop17060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    style: {
      stopColor: "#dac7bd"
    },
    id: "stop17062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    style: {
      stopColor: "#f1e3cf"
    },
    id: "stop17064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#faeed6"
    },
    id: "stop17066"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M716.18 386.28c-11.79 61.54-70.87 132.66-132.27 176.37-18.07 12.8-36.32 23.27-53.55 30.33 3.24-3.67 103.58-118.93 133.92-204.95 30-85.31-3.34-93.56-1.79-101.06.84-4.13 21.64 2.7 37.49 22.64l.13.06c13.02 16.25 22.84 41.32 16.07 76.61z",
    id: "path17069",
    style: {
      fill: "url(#SVGID_7_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 630.084,
    y1: 436.545,
    x2: 630.084,
    y2: 166.552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7a28b"
    },
    id: "stop17071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#8e6a81"
    },
    id: "stop17073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#b5999f"
    },
    id: "stop17075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    style: {
      stopColor: "#dac7bd"
    },
    id: "stop17077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    style: {
      stopColor: "#f1e3cf"
    },
    id: "stop17079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#faeed6"
    },
    id: "stop17081"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M646.76 406.85c0 .07 0 .13-.07.2-5.65 17.09-10.77 28.04-11.49 29.5 14.51-49.78 12.91-130.72-24.66-153.8 0 0-24.29-87.74-27.55-110.41-.35-2.76-.46-4.57-.13-5.14 3.67-6.26 86.63 32.82 94.25 122.86 3.76 44.29-21.34 89.54-30.35 116.79z",
    id: "path17084",
    style: {
      fill: "url(#SVGID_8_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 557.957,
    y1: 711.846,
    x2: 557.957,
    y2: 431.149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7a28b"
    },
    id: "stop17086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#8e6a81"
    },
    id: "stop17088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#b5999f"
    },
    id: "stop17090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    style: {
      stopColor: "#dac7bd"
    },
    id: "stop17092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    style: {
      stopColor: "#f1e3cf"
    },
    id: "stop17094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#faeed6"
    },
    id: "stop17096"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M695.8 553.5c-10.74 42.85-168.69 56.24-216.63 85.51-39.49 24.11-34.06 35.85-26.78 40.12 1.72.99 3.51 1.55 4.9 1.79 6.98 1.22-5.42-18.06 15.55-23.13 20.76-4.96 21.61 18.1 15.81 25.62 0 0-18.39 29.48-47.72 28.4-24.34-.95-33.47-59.22-24.1-92.11v-.07c1.93-6.93 4.74-12.72 8.4-16.62 20.69-22.17 110.99 4.02 182.76-60.44 69.47-62.38 87.34-102.07 90.97-110.82 1.21-2.95 2.47 5.2 3.21 18.82v.13c1.3 26.75.59 74.76-6.37 102.8z",
    id: "path17099",
    style: {
      fill: "url(#SVGID_9_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M695.8 553.5c-10.74 42.85-168.69 56.24-216.63 85.51-39.49 24.11-34.06 35.85-26.78 40.12 0 0-30.12-28.87-13.98-68.08 15.95-38.77 94.3.02 181.64-34.96 66.89-26.89 79.66-97.1 82.12-125.4 1.3 26.76.59 74.77-6.37 102.81z",
    id: "path17101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M488.65 683.42s-18.39 29.48-47.72 28.4c-24.34-.95-33.47-59.22-24.1-92.11-.07 2.78-1.09 67.31 25.05 78.77 26.55 11.63 39.92-21.14 40.56-28.62.57-7.53-9.61-12.06-9.61-12.06 20.76-4.96 21.61 18.1 15.82 25.62z",
    id: "path17103"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M716.18 386.28c-11.79 61.54-70.87 132.66-132.27 176.37-12.99 6.97-23.54 11.72-28.97 12.32 0 0 106.6-98.74 134.86-161.76 27.71-61.87 10.19-103.61 10.19-103.61l.13.06c13.01 16.26 22.83 41.33 16.06 76.62z",
    id: "path17105"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M646.76 406.85c0 .07 0 .13-.07.2-5.65 17.09-10.77 28.04-11.49 29.5 14.51-49.78 12.91-130.72-24.66-153.8 0 0-24.29-87.74-27.55-110.41l.96-.13s40.67 30.9 55.98 80.55c15.39 49.93 13.31 121.2 6.83 154.09z",
    id: "path17107"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M628.31 460.34s38.31 3.07 53.91-32.45c15.43-35.14 26.23-74.71 17.33-98.54-8.88-23.78-22.09-19.27-22.09-19.27s6.6 11.23-6.16 55.37c-12.92 44.67-42.99 94.89-42.99 94.89z",
    id: "path17109"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M551.07 576.41s63.57 17.85 100.51-18.88c36.32-36.1 37.3-88.97 34.05-92.17-3.25-3.21-10.54 11.91-56.6 57.52-47.07 46.61-77.96 53.53-77.96 53.53z",
    id: "path17111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M597.29 184.25s42.31 34.71 49.42 97.75c7.18 63.63 26.61 11.2 25.87-17.99-.73-29.05-38.46-70.56-75.29-79.76z",
    id: "path17113"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M507.11 592.21s83.38 1.47 133.61-34.03c49.2-34.78 59.34-91.29 59.34-91.29s-2.34 73.61-67.68 104.27c-58.35 27.38-125.27 21.05-125.27 21.05z",
    id: "path17115"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M612.87 516.56s70.62-83 81.25-119.92c10.53-36.56 11.05-60.59 11.05-60.59s23.71 70-92.3 180.51z",
    id: "path17117"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M597.29 184.25s55.54 46.19 54.13 175.43c0 0 17.68-116.11-54.13-175.43z",
    id: "path17119"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M417.15 633.69c3.61 28.57 14.44-21.22 26.83-31.07 12.33-9.81-26.93-16.68-26.83 31.07z",
    id: "path17121"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M451.6 599.48c-12.37 6.42-21.81 36.31-12.42 51.32 9.39 15.01 23.3-12.15 85.97-31.1 61.37-18.55-37.98-38.68-73.55-20.22z",
    id: "path17123"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M704.46 361.8c-8.21-26.11-13.16 29.39-10.34 34.84 2.83 5.45 14.69-21.02 10.34-34.84z",
    id: "path17125"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M617.85 192.53c-8.45-2.14 12.48 47.41 22.15 53.68 9.64 6.26 16.38-43.92-22.15-53.68z",
    id: "path17127"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M433.93 692.57c-5.65-16.07 22.2-3.9 34.23-9.37 11.98-5.45-.11 18.34-16.28 17.71-16.24-.63-17.95-8.34-17.95-8.34z",
    id: "path17129"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g17227"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.86,
    y1: 592.071,
    x2: 483.86,
    y2: 282.8,
    gradientTransform: "matrix(-1 0 0 1 675.061 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7a28b"
    },
    id: "stop17156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#8e6a81"
    },
    id: "stop17158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#b5999f"
    },
    id: "stop17160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    style: {
      stopColor: "#dac7bd"
    },
    id: "stop17162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    style: {
      stopColor: "#f1e3cf"
    },
    id: "stop17164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#faeed6"
    },
    id: "stop17166"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.95 381.9c11.94 61.51 72.19 133.63 135.32 178.62 18.69 13.26 37.56 24.14 55.4 31.55-3.38-3.8-107.17-121.83-138.34-208.18-30.43-84.55 3.02-92.57 1.43-99.95-.86-4.05-21.7 2.59-37.57 22.16l-.13.06c-13.05 15.97-22.92 40.71-16.11 75.74z",
    id: "path17169",
    style: {
      fill: "url(#SVGID_11_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 492.196,
    y1: 432.538,
    x2: 492.196,
    y2: 166.553,
    gradientTransform: "matrix(-1 0 0 1 675.061 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7a28b"
    },
    id: "stop17171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#8e6a81"
    },
    id: "stop17173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#b5999f"
    },
    id: "stop17175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    style: {
      stopColor: "#dac7bd"
    },
    id: "stop17177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    style: {
      stopColor: "#f1e3cf"
    },
    id: "stop17179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#faeed6"
    },
    id: "stop17181"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.14 402.75c0 .07 0 .13.07.2 5.81 17.12 11.06 28.12 11.8 29.59-14.95-49.83-13.71-129.99 23.94-152.61 0 0 23.69-85.76 26.75-107.77.33-2.67.42-4.44.08-4.98-3.72-6.06-86.32 31.81-93.67 119.77-3.67 43.63 21.79 88.61 31.03 115.8z",
    id: "path17184",
    style: {
      fill: "url(#SVGID_12_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.763,
    y1: 716.201,
    x2: 414.763,
    y2: 426.745,
    gradientTransform: "matrix(-1 0 0 1 675.061 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7a28b"
    },
    id: "stop17186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#8e6a81"
    },
    id: "stop17188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#b5999f"
    },
    id: "stop17190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    style: {
      stopColor: "#dac7bd"
    },
    id: "stop17192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    style: {
      stopColor: "#f1e3cf"
    },
    id: "stop17194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#faeed6"
    },
    id: "stop17196"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.76 550.19c11.05 43.81 173.48 59.15 223.5 89.85 41.43 25.44 36 37.57 28.51 41.92a15.7 15.7 0 0 1-5.06 1.81c-7.24 1.18 5.3-18.71-16.57-24.2-21.61-5.37-22.13 18.53-16 26.42 0 0 19.63 30.96 50.18 30.2 25.39-.67 33.66-61.27 23.22-95.43v-.07c-2.15-7.17-5.18-13.17-9.05-17.23-21.85-23.01-114.68 3-189.07-63.62-71.16-63.72-89.36-103.71-93.05-112.49-1.23-2.96-2.49 5.19-3.22 18.83v.13c-1.28 26.88-.52 75.36 6.61 103.88z",
    id: "path17199",
    style: {
      fill: "url(#SVGID_13_)"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M117.76 550.19c11.05 43.81 173.48 59.15 223.5 89.85 41.43 25.44 36 37.57 28.51 41.92 0 0 30.76-29.63 13.23-70.35-17.23-40.03-97.51-.95-187.68-37.69-68.53-28.02-81.64-99.15-84.17-127.6-1.28 26.87-.52 75.35 6.61 103.87z",
    id: "path17201"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M332.15 685.98s19.63 30.96 50.18 30.2c25.39-.67 33.66-61.27 23.22-95.43.14 2.88 2.55 69.86-24.47 81.48-27.46 11.8-41.92-22.5-42.71-30.28-.72-7.82 9.78-12.4 9.78-12.4-21.62-5.36-22.14 18.55-16 26.43z",
    id: "path17203"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M96.95 381.9c11.94 61.51 72.19 133.63 135.32 178.62 13.4 7.24 24.29 12.2 29.88 12.86 0 0-109.72-101.13-138.54-164.51-28-61.63-10.43-102.77-10.43-102.77l-.13.06c-13.04 15.97-22.91 40.71-16.1 75.74z",
    id: "path17205"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M167.14 402.75c0 .07 0 .13.07.2 5.81 17.12 11.06 28.12 11.8 29.59-14.95-49.83-13.71-129.99 23.94-152.61 0 0 23.69-85.76 26.75-107.77l-.97-.12s-40.44 29.99-55.49 78.41c-15.2 48.98-12.81 119.5-6.1 152.3z",
    id: "path17207"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M186.14 456.48s-38.91 2.83-54.83-32.89c-15.66-35.15-26.58-74.49-17.66-98.01 8.89-23.42 22.16-18.93 22.16-18.93s-6.6 11.05 6.37 54.78c13.21 44.53 43.96 95.05 43.96 95.05z",
    id: "path17209"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M266.15 574.9S201 592.56 162.93 554.7c-37.18-36.98-38.28-90.35-34.99-93.55 3.29-3.2 10.73 12.06 57.84 58.51 48.56 47.87 80.37 55.24 80.37 55.24z",
    id: "path17211"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M215.5 183.72s-42.09 33.73-48.91 95.39c-6.94 62.73-26.68 10.93-26.02-17.71.65-28.39 38.18-68.77 74.93-77.68z",
    id: "path17213"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M311.64 591.52s-85.84.68-137.59-36.07c-50.34-35.76-60.73-92.86-60.73-92.86s2.47 74.38 69.34 106.18c60.11 28.58 128.98 22.75 128.98 22.75z",
    id: "path17215"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M202.25 513.38s-72.22-84.13-83.03-121.06c-10.66-36.38-11.2-60.16-11.2-60.16s-23.87 69.35 94.23 181.22z",
    id: "path17217"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M215.5 183.72s-55.27 44.9-53.29 172.07c0-.01-18.22-114.38 53.29-172.07z",
    id: "path17219"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M405.51 635.22c-3.16 29.58-15.42-22.08-28.44-32.36-12.94-10.21 27.55-16.89 28.44 32.36z",
    id: "path17221"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M369.12 599.55c12.93 6.73 23.31 37.71 13.85 53.15-9.48 15.46-24.42-12.85-89.57-33.09-63.46-19.71 38.64-39.38 75.72-20.06z",
    id: "path17223"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M389.25 696.19c5.57-16.67-23.19-4.34-35.81-10.18-12.54-5.81.44 19.11 17.27 18.66 16.91-.46 18.54-8.48 18.54-8.48z",
    id: "path17225"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 715.2,
    cy: 1329.154,
    r: 44.541,
    gradientTransform: "matrix(.7749 -.3013 .133 .342 -79.34 336.945)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop17231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop17233"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 190.163,
    cy: 1197.456,
    r: 44.544,
    gradientTransform: "matrix(.803 .2154 -.095 .3544 152.258 117.045)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop17238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop17240"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 719.8,
    cy: 1295.338,
    r: 72.01,
    gradientTransform: "matrix(-.2282 -.7995 .3528 -.1007 363.2 974.685)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop17245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop17247"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 788.185,
    cy: -3.98,
    r: 72.015,
    gradientTransform: "matrix(-.4727 -.6839 .3018 -.2086 514.33 950.563)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop17252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop17254"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style16952"
  }, ".st10{fill:#4e2f5f}.st10,.st11{opacity:.5}.st11,.st12{fill:#fff}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFrameSilver);
export default __webpack_public_path__ + "static/media/user_frame_silver.ad76d98cae52aa204c871b7fe7afa533.svg";
export { ForwardRef as ReactComponent };